import React, { useEffect, useRef, useState, useMemo } from "react";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import AdLayout from '../components/AdLayout';
import ScrollButton from '../component/ScrollButton';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axiosInstance from "../axiosInstance";
import { API_URL_All } from "../api";
import { useParams, useNavigate } from "react-router-dom";
import * as general from '../libs/general';

import JoditEditor from 'jodit-react';

const convertToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
};

const AddOrUpdatePost = ({ placeholder }) => {

  const editor = useRef(null);

  const config = useMemo(() => ({
    readonly: false,
    placeholder: placeholder || 'Start typing...',
  }), [placeholder]);

  const navigate = useNavigate();

  const { id } = useParams();
  const { link } = useParams();
  const [post, setPost] = useState(null);

  useEffect(() => {
    const fetchPost = async () => {
      try {
        const response = await axiosInstance.get(`${API_URL_All}/api/posts/${id}/${link}`);
        setPost(response.data);
      } catch (error) {
        console.error("Error fetching post:", error);
      }
    };

    fetchPost();
  }, [id]);

  if (!post) return <p>Loading...</p>;

  const handleBack = () => {
    navigate(general.popUrl());
  };

  // Input check
  const validationSchema = Yup.object({
    title: Yup.string().required("Hãy thêm Tiêu đề cho bài viết"),
    link: Yup.string().required("Hãy thêm Link cho bài viết"),
    description: Yup.string().required("Hãy thêm Mô tả cho bài viết"),
    content: Yup.string().required("Hãy thêm Nội dung cho bài viết"),
    // mainImageUrl: Yup.mixed().required("Hãy thêm Ảnh bìa cho bài viết")
  });

  const handleSubmit = async (postDto) => {
    try {
      const formData = new FormData();
      formData.append("title", postDto.title);
      formData.append("link", postDto.link);
      formData.append("description", postDto.description);
      formData.append("content", postDto.content);

      if (postDto.mainImageUrl && postDto.mainImageUrl instanceof File) {
        const mainImageUrlBase64 = await convertToBase64(postDto.mainImageUrl);
        formData.append("mainImageUrl", mainImageUrlBase64);
      } else {
        formData.append("mainImageUrl", "");
      }

      await axiosInstance.put(`${API_URL_All}/api/posts/${id}`, formData, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      toast.success(`${id === 0 ? "Thêm" : "Chỉnh sửa"} thành công.`, { position: "top-right" });
    } catch (error) {
      toast.error("Đã xảy ra lỗi: ", error.response?.data || error.message);
    }
  };

  return (
    <AdLayout>
      <Formik
        initialValues={{
          title: post.title,
          link: post.link,
          description: post.description,
          mainImageUrl: post.mainImageUrlUrl || null,
          content: post.content,
        }}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ values, setFieldValue, setFieldTouched }) => (
          <Form>
            <div className="container-fluid sticky-top px-3 py-2">
              <div className="row bg-dark">
                <div className="col-12 col-md-2 py-1 fw-bold text-white text-uppercase d-flex align-items-center">
                  {id === 0 ? "Thêm" : "Chỉnh sửa"} bài viết
                </div>
                <div className="col-12 col-md-8 order-3 order-md-1 py-1">
                  <button type="submit" className="btn btn-primary btn-sm mx-1" title="Lưu">
                    <i className="fas fa-save"></i>
                  </button>
                  <button className="btn btn-secondary btn-sm mx-1" title="Quay lại" onClick={() => handleBack()}>
                    <i className="fas fa-arrow-left"></i>
                  </button>
                </div>
              </div>
            </div>

            <div className="container-fluid">
              <div className="mb-2 w-50">
                <label className="form-label  fw-bold required">Tiêu đề</label>
                <Field
                  type="text"
                  className="form-control"
                  name="title"
                  placeholder="Nhập tiêu đề bài viết"
                />
                <ErrorMessage name="title" component="div" className="text-danger" />
              </div>

              <div className="mb-2 w-50">
                <label className="form-label  fw-bold required">Link</label>
                <Field
                  type="text"
                  className="form-control"
                  name="link"
                  placeholder="Nhập link bài viết"
                />
                <ErrorMessage name="title" component="div" className="text-danger" />
              </div>

              <div className="mb-2 w-50">
                <label className="form-label fw-bold required">Mô tả</label>
                <Field
                  as="textarea"
                  className="form-control"
                  name="description"
                  placeholder="Nhập Description"
                />
                <ErrorMessage name="description" component="div" className="text-danger" />
              </div>

              <div className="mb-2 w-50">
                <label className="form-label fw-bold required">Ảnh chính (416 x 233 px)</label>
                <input
                  type="file"
                  accept="image/*"
                  className="form-control"
                  onChange={(e) => setFieldValue("mainImageUrl", e.target.files[0])}
                />
                {typeof values.mainImageUrl == "string" && values.mainImageUrl && (
                  <div>
                    <img
                      src={values.mainImageUrl}
                      alt="Ảnh hiện tại"
                      style={{ maxWidth: "100px", marginTop: "10px" }}
                    />
                  </div>
                )}
                <ErrorMessage name="mainImageUrl" component="div" className="text-danger" />
              </div>

              <div className="">
                <label className="form-label fw-bold required">Nội dung bài viết</label>
                <JoditEditor
                  ref={editor}
                  value={values.content}
                  config={config}
                  tabIndex={1} // tabIndex of textarea
                  onChange={(content) => setFieldValue("content", content)}
                  onBlur={() => setFieldTouched("content", true, true)}
                />
                <ErrorMessage name="content" component="div" className="text-danger" />
              </div>
            </div>
          </Form>
        )}
      </Formik>
      <ScrollButton />
    </AdLayout>
  );
};

export default AddOrUpdatePost;
